import { isGPhone } from './isGPhone';
import { isIPhone } from './isIPhone';
import { isPC } from './isPC';
import { isHarmony } from './isHarmony';

/**
 * 平台类型
 */
export type Platform = 'pc' | 'harmony' | 'iphone' | 'gphone' | 'unknown';

/**
 * 获取当前平台类型
 *
 * @returns {Platform} 平台类型
 * - 'pc': PC设备
 * - 'harmony': 纯血鸿蒙设备
 * - 'iphone': iPhone设备（包括iPad/iPod）
 * - 'gphone': Android设备（包括套皮鸿蒙）
 * - 'unknown': 未知平台
 *
 * @example
 * ```ts
 * const platform = getPlatform();
 * if (platform === 'harmony') {
 *   // 纯血鸿蒙平台特有处理
 * }
 * ```
 */
export function getPlatform(): Platform {
  try {
    if (isPC()) return 'pc';
    if (isHarmony()) return 'harmony';
    if (isIPhone()) return 'iphone';
    if (isGPhone()) return 'gphone';
    return 'unknown';
  } catch (error) {
    console.warn('获取平台类型失败:', error);
    return 'unknown';
  }
}